module.exports = __webpack_public_path__ + "static/media/nine-tokens.e2e95f09.svg";